import { combineReducers } from '@reduxjs/toolkit';
import {
  accountReducer,
  analysisReducer,
  authReducer,
  configReducer,
  customerReducer,
  dashboardPageReducer,
  appStateReducer,
  transactionReducer,
  activityReducer,
  activityPageReducer,
  preferencesReducer,
  loanDecisionsReducer,
  userReducer,
  organizationReducer,
} from '@algoan/dashboard/store/slice';

export const rootReducer = combineReducers({
  account: accountReducer,
  analysis: analysisReducer,
  appConfig: configReducer,
  appState: appStateReducer,
  auth: authReducer,
  customer: customerReducer,
  dashboardPage: dashboardPageReducer,
  transaction: transactionReducer,
  activity: activityReducer,
  activityPage: activityPageReducer,
  preferences: preferencesReducer,
  loanDecisions: loanDecisionsReducer,
  user: userReducer,
  organization: organizationReducer,
});
